import { render, staticRenderFns } from "./PullNewDoctor.vue?vue&type=template&id=3cd90e85&scoped=true"
import script from "./PullNewDoctor.vue?vue&type=script&lang=js"
export * from "./PullNewDoctor.vue?vue&type=script&lang=js"
import style0 from "./PullNewDoctor.vue?vue&type=style&index=0&id=3cd90e85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd90e85",
  null
  
)

export default component.exports